<section [ngClass]="['products-grid', gridSectionClass]">
  <org-product-card
    *ngFor="let product of productList"
    [product]="product"
  />
</section>
